import { stateCard } from './Card.style';

type TProp = {
  imgSrc: string;
  title: string;
  content: string;
};

export const StateCard = ({ imgSrc, title, content }: TProp) => {
  return (
    <stateCard.Container>
      <stateCard.Img src={imgSrc} alt={title} />
      <stateCard.Title>{title}</stateCard.Title>
      <stateCard.Content>{content}</stateCard.Content>
    </stateCard.Container>
  );
};
